import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doAdd: { api: 'T0080CoachingFeeService.M30101_doAdd'},
    getEdit: { api: 'T0080CoachingFeeService.M30101_getEdit'},
    doEdit: { api: 'T0080CoachingFeeService.M30101_doEdit'},
    doRead: { api: 'T0080CoachingFeeService.M30101_doRead'},
    doDelete: { api: 'T0080CoachingFeeService.M30101_doDelete'},
    doBrowse: { api: 'T0080CoachingFeeService.M30101_doBrowse'},
  },
}

const module = {
  state: {
    PageConst,
    dropdownList: {
      rateType: [],
      courseSettingNo: [],
      pricingCategory: [],
    },
    defaultDoBrowse: {
      searchInfo: {
        rate_type: null,
        course_setting_no: null,
        pricing_category: null,
      },
      orderBy: {},
      rows: [],
      doBrowseStatus: 'init'
    },
  },

  getters: {},

  mutations: {},

  actions: {
    async M30101_init({ commit, state }) {
      const res = await ApiUtils.postData({
        data: [{
          api: 'T0080CoachingFeeService.M30101_getDropdownData',
          input: {}
        }]
      })
      commit('setState', {
        dropdownList: res[0].output
      })
    },
    async M30101_clearSearch({ commit, state }) {
      commit('setState', {
        _removeReactivity: true,
        ...state.defaultDoBrowse
      })
    },
    async M30101_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
    async M30101_updateFees({ state }, payload) {
      return await ApiUtils.postData({
        data: [
          {
            api: 'T0080CoachingFeeService.M30101_updateFees',
            input: payload
          },
        ]
      }).then(res => {
        window.vue.$dialog.notify.success('指導料金を更新しました');
        return res[0].output
      }).catch(err => {
        window.vue.$dialog.notify.error('指導料金を更新に失敗しました');
        throw err;
      });
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
